import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Oggetto del Servizio",
    content: (
      <>
        <p>
          Forfy è un'applicazione web che supporta i professionisti italiani in regime forfettario
          (ai sensi della Legge 190/2014 e successive modifiche) nel monitoraggio delle fatture,
          nella gestione dei clienti, nel calcolo indicativo delle imposte e dei contributi INPS,
          e nella gestione dei timesheet.
        </p>
        <p>
          Il servizio include Olli, un assistente AI per supporto fiscale indicativo, basato su
          tecnologia Anthropic Claude API.
        </p>
      </>
    ),
  },
  {
    title: "2. Disclaimer — Calcoli Indicativi, Non Consulenza Professionale",
    content: (
      <>
        <p>
          Forfy non è un commercialista, un consulente fiscale né un CAF. Tutti i calcoli, le stime
          e le informazioni forniti dal servizio — incluse le risposte di Olli — hanno carattere
          puramente indicativo e orientativo.
        </p>
        <p>L'utente riconosce e accetta che:</p>
        <ul>
          <li>
            I risultati dei calcoli sono stime basate sui parametri normativi vigenti al momento
            dell'elaborazione e sui dati inseriti dall'utente
          </li>
          <li>
            Forfy non garantisce l'esattezza, la completezza o l'aggiornamento in tempo reale dei
            calcoli, in particolare a seguito di variazioni normative (aliquote INPS, soglie di
            accesso al regime, modifiche legislative)
          </li>
          <li>
            Le risposte di Olli sono generate da un modello AI e non costituiscono in alcun modo
            parere professionale vincolante
          </li>
          <li>
            È responsabilità esclusiva dell'utente verificare i risultati con il proprio
            commercialista o consulente fiscale abilitato
          </li>
          <li>
            Forfy non si assume alcuna responsabilità per decisioni fiscali, contributive o
            finanziarie prese sulla base dei calcoli o delle risposte fornite
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "3. Requisiti di Accesso",
    content: (
      <>
        <p>L'utilizzo di Forfy è riservato a:</p>
        <ul>
          <li>Persone fisiche maggiorenni (18 anni compiuti)</li>
          <li>
            Titolari di Partita IVA italiana in regime forfettario, o che intendono aprirne una
          </li>
          <li>Professionisti operanti a titolo individuale (non società)</li>
        </ul>
        <p>Registrandosi, l'utente dichiara di soddisfare tali requisiti.</p>
      </>
    ),
  },
  {
    title: "4. Account Utente e Sicurezza",
    content: (
      <>
        <p>
          L'utente è responsabile della riservatezza e della sicurezza delle proprie credenziali di
          accesso. In caso di accesso non autorizzato sospetto, l'utente è tenuto a notificarlo
          tempestivamente a{" "}
          <a href="mailto:privacy@forfy.it" className="text-forfy-400 underline hover:text-forfy-700">
            privacy@forfy.it
          </a>
          .
        </p>
        <p>
          È consentito un solo account per persona fisica. La creazione di account multipli può
          comportare la sospensione del servizio.
        </p>
      </>
    ),
  },
  {
    title: "5. Piani e Pagamenti",
    content: (
      <>
        <p>Forfy offre:</p>
        <ul>
          <li>
            Piano gratuito con funzionalità limitate, attivato automaticamente al termine del
            periodo di accesso completo
          </li>
          <li>
            Piano a pagamento con accesso completo a tutte le funzionalità, disponibile in
            abbonamento annuale
          </li>
        </ul>
        <p>
          I prezzi sono indicati IVA inclusa. Il pagamento avviene tramite processori di pagamento
          terzi. Forfy non tratta direttamente i dati della carta di credito dell'utente.
        </p>
        <p>
          Il periodo di prova (accesso completo) non si converte automaticamente in abbonamento a
          pagamento. Al termine del periodo, l'account passa al piano gratuito senza addebiti.
        </p>
        <p>
          In caso di abbonamento attivo, la disdetta può essere effettuata in qualsiasi momento
          tramite l'interfaccia dell'applicazione o scrivendo a{" "}
          <a href="mailto:privacy@forfy.it" className="text-forfy-400 underline hover:text-forfy-700">
            privacy@forfy.it
          </a>
          , con effetto al termine del periodo già pagato.
        </p>
      </>
    ),
  },
  {
    title: "6. Cancellazione dell'Account e Portabilità dei Dati",
    content: (
      <>
        <p>L'utente può richiedere in qualsiasi momento:</p>
        <ul>
          <li>
            La cancellazione dell'account e di tutti i dati associati, scrivendo a{" "}
            <a href="mailto:privacy@forfy.it" className="text-forfy-400 underline hover:text-forfy-700">
              privacy@forfy.it
            </a>
          </li>
          <li>
            L'esportazione dei propri dati (fatture, anagrafiche clienti) nei formati disponibili
          </li>
        </ul>
        <p>
          La cancellazione sarà effettuata entro 30 giorni dalla richiesta, salvo obblighi di
          conservazione previsti dalla legge. Per i dettagli sul trattamento dei dati si rimanda
          alla{" "}
          <a
            href="https://www.iubenda.com/privacy-policy/43603356"
            target="_blank"
            rel="noopener noreferrer"
            className="text-forfy-400 underline hover:text-forfy-700"
          >
            Privacy Policy
          </a>
          .
        </p>
      </>
    ),
  },
  {
    title: "7. Proprietà Intellettuale",
    content: (
      <>
        <p>
          Tutti i contenuti del servizio (testi, grafica, loghi, software, struttura del database,
          prompt AI) sono di proprietà di Matteo Panigada o utilizzati su licenza. È vietata la
          riproduzione, distribuzione o modifica senza autorizzazione scritta.
        </p>
        <p>
          I dati fiscali inseriti dall'utente (fatture, dati anagrafici, incassi) restano di
          esclusiva proprietà dell'utente stesso. Forfy non rivendica diritti su tali dati.
        </p>
      </>
    ),
  },
  {
    title: "8. Sospensione e Interruzione del Servizio",
    content: (
      <>
        <p>
          Forfy si riserva il diritto di sospendere o limitare l'accesso all'account in caso di:
        </p>
        <ul>
          <li>Violazione dei presenti Termini</li>
          <li>Utilizzo del servizio per finalità illecite o fraudolente</li>
          <li>
            Attività che compromettano la sicurezza o il funzionamento della piattaforma
          </li>
        </ul>
        <p>
          In caso di sospensione per violazione, l'utente sarà notificato con almeno 7 giorni di
          preavviso, salvo casi di urgenza che richiedano un'azione immediata.
        </p>
      </>
    ),
  },
  {
    title: "9. Limitazione di Responsabilità",
    content: (
      <>
        <p>
          Nei limiti consentiti dalla legge applicabile, Matteo Panigada non sarà responsabile per:
        </p>
        <ul>
          <li>
            Danni diretti o indiretti derivanti dall'utilizzo o dall'impossibilità di utilizzo del
            servizio
          </li>
          <li>
            Errori nei calcoli fiscali dovuti a dati errati inseriti dall'utente o a variazioni
            normative non ancora recepite
          </li>
          <li>
            Perdite economiche o di opportunità derivanti da decisioni basate sui risultati di Forfy
            o sulle risposte di Olli
          </li>
          <li>
            Interruzioni temporanee del servizio dovute a manutenzione, malfunzionamenti di
            infrastrutture terze (Firebase, Anthropic), o cause di forza maggiore
          </li>
          <li>
            Eventuali danni derivanti da accessi non autorizzati all'account dell'utente imputabili
            a negligenza dello stesso nella custodia delle credenziali
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "10. Uso Consentito",
    content: (
      <>
        <p>
          L'utente si impegna a utilizzare Forfy esclusivamente per le finalità previste dal
          servizio. Sono vietati:
        </p>
        <ul>
          <li>L'accesso automatizzato tramite bot, scraper o strumenti analoghi</li>
          <li>Il tentativo di accesso non autorizzato a dati di altri utenti</li>
          <li>
            L'utilizzo del servizio per finalità diverse da quelle personali e professionali del
            titolare dell'account
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "11. Legge Applicabile e Foro Competente",
    content: (
      <>
        <p>
          I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia tra Forfy
          e utenti professionali (B2B) sarà competente il Foro di Milano. Per gli utenti consumatori
          si applicano le norme imperative del Codice del Consumo (D.Lgs. 206/2005), incluso
          l'Art. 66-bis sul foro del consumatore.
        </p>
        <p>
          In caso di controversia, l'utente è invitato a contattare{" "}
          <a href="mailto:privacy@forfy.it" className="text-forfy-400 underline hover:text-forfy-700">
            privacy@forfy.it
          </a>{" "}
          per una risoluzione amichevole. Forfy si impegna a rispondere entro 5 giorni lavorativi.
        </p>
      </>
    ),
  },
  {
    title: "12. Modifiche ai Termini",
    content: (
      <p>
        Ci riserviamo il diritto di modificare i presenti Termini. In caso di modifiche
        sostanziali, gli utenti registrati saranno informati tramite notifica in-app e/o email con
        un preavviso di almeno 30 giorni. L'utilizzo continuato del servizio dopo la notifica
        costituisce accettazione delle modifiche.
      </p>
    ),
  },
  {
    title: "13. Contatti",
    content: (
      <div>
        <p>Matteo Panigada</p>
        <p>Milano (MI), Italia</p>
        <p>P.IVA: 11814150964</p>
        <p>
          Email:{" "}
          <a href="mailto:privacy@forfy.it" className="text-forfy-400 underline hover:text-forfy-700">
            privacy@forfy.it
          </a>
        </p>
      </div>
    ),
  },
];

export default function TerminiPage() {
  return (
    <div className="min-h-screen bg-[#FFF5F0]">
      {/* Header */}
      <header className="border-b border-neutral-200 bg-white/80 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-medium text-neutral-600 hover:text-forfy-400 transition-colors"
          >
            <ArrowLeft size={16} />
            Torna all'app
          </Link>
          <span className="font-display font-bold text-lg text-forfy-400">forfy</span>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-5 py-10 md:py-14">
        <h1 className="font-display text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-3">
          Termini e Condizioni d'uso
        </h1>
        <p className="font-body text-sm text-neutral-500 mb-10">
          Ultimo aggiornamento: 13 aprile 2026 &middot; Versione 2026-04-13-v1.0
        </p>

        <div className="space-y-10">
          {SECTIONS.map((section) => (
            <section key={section.title}>
              <h2 className="font-display text-xl md:text-2xl font-semibold text-forfy-400 mb-4">
                {section.title}
              </h2>
              <div className="font-body text-[#1A1A1A] text-base leading-7 space-y-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:leading-7">
                {section.content}
              </div>
              <hr className="mt-10 border-neutral-200" />
            </section>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-200 bg-white/60">
        <div className="max-w-3xl mx-auto px-5 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-neutral-500 font-body">
          <span>&copy; {new Date().getFullYear()} Forfy &mdash; Matteo Panigada</span>
          <div className="flex gap-4">
            <a
              href="https://www.iubenda.com/privacy-policy/43603356"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-forfy-400 transition-colors"
            >
              Privacy Policy
            </a>
            <a
              href="https://www.iubenda.com/privacy-policy/43603356/cookie-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-forfy-400 transition-colors"
            >
              Cookie Policy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
